import {
    Drawer,
    DrawerBody,
    DrawerContent,
    useDisclosure,
    Button,
    DrawerOverlay,
    DrawerHeader,
    CloseButton,
    Text,
    Flex,
    Divider,
} from '@chakra-ui/react'
import { useLocation } from 'react-router-dom';
import { useEffect } from "react";
import PropTypes from "prop-types";
import { isMobile } from 'mobile-device-detect';
import { IoFilterSharp } from "react-icons/io5";
import { toggleSelectedRegion } from '../../utils/helpers';

const RegionFilterDrawer = (props) => {
    const { isOpen, onToggle, onClose } = useDisclosure();
    const location = useLocation();

    const { regions, selectedRegions, setSelectedRegions } = props

    useEffect(() => {
        onClose()
    }, [location, onClose]);

    return (
        <div className='MobileDrawer'>
            <Button
                onClick={onToggle}
                variant={'outline'}
                borderColor={'teal.500'}
                color={'teal.500'}
                leftIcon={<IoFilterSharp />}
            >
                {selectedRegions.length > 0 ? selectedRegions.length : 'Filter'}
            </Button>
            <Drawer placement="right" isOpen={isOpen} onClose={onClose} sx={{ top: 72 }}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader>
                        <Flex justifyContent="space-between" alignItems="center">
                            <Text fontSize={18} fontWeight={700}>Filter</Text>
                            <CloseButton onClick={onClose} />
                        </Flex>
                    </DrawerHeader>
                    <DrawerBody p="4" display={'flex'} flexDirection={'column'}>
                        <Divider />
                        <Text my={4}>Regions</Text>
                        <Flex height={70} bg='#fff' align='center' justify='start' flexWrap={'wrap'} gap={1}>
                            {regions.map((region) => (
                                <Button
                                    key={region.id}
                                    variant='solid'
                                    onClick={() => toggleSelectedRegion(region.id, selectedRegions, setSelectedRegions)}
                                    borderRadius='99px'
                                    border={'solid 1px'}
                                    borderColor={'teal.100'}
                                    bg={selectedRegions.includes(region.id) ? 'teal.100' : 'transparent'}
                                    color={'teal.700'}
                                    fontWeight={500}
                                    padding={'4px 16px'}
                                    size={'xs'}
                                    _hover={{
                                        bg: isMobile ? '' : 'teal.200',
                                    }}
                                    _active={{ bg: 'transparent' }}
                                >
                                    {region.name}
                                </Button>
                            ))}
                        </Flex>
                        <Flex mt={'auto'} alignItems={'center'} justifyContent={'space-between'}>
                            <Button variant="ghost" color={'teal.500'} onClick={() => toggleSelectedRegion([], selectedRegions, setSelectedRegions)}>
                                Clear All
                            </Button>
                            <Button backgroundColor={'teal.500'} _hover={{ backgroundColor: 'teal.400' }} onClick={onClose}>
                                Show Results
                            </Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </div>
    )
}

RegionFilterDrawer.propTypes = {
    regions: PropTypes.array,
    selectedRegions: PropTypes.array,
    setSelectedRegions: PropTypes.func,
}

RegionFilterDrawer.defaultProps = {
    regions: [],
    selectedRegions: [],
    setSelectedRegions: () => {},
}

export { RegionFilterDrawer }
